const POSITION = {
    START_POSITION: 'practice-start',
    OK_POSITION: 'practice-stop',
    CLEAR_POSITION: 'practice-clear',
};

export const LETTER_POSITION_PREFIX = 'letter-';

// Aims the pointer at a letter key. The key is located in the DOM and measured
// at runtime, so any letter works without a matching coordinate rule.
export const letterPosition = letter => `${LETTER_POSITION_PREFIX}${letter}`;

export const isLetterPosition = position =>
    Boolean(position) && position.startsWith(LETTER_POSITION_PREFIX);

export const letterFromPosition = position => position.slice(LETTER_POSITION_PREFIX.length);

// Elements the non-letter positions aim at, looked up inside the pointer's
// containing block. Positions absent from this map are placed by stylesheet
// alone - START_POSITION is a resting corner, not an on-screen element.
export const POSITION_TARGETS = {
    [POSITION.OK_POSITION]: '.ok-button',
    [POSITION.CLEAR_POSITION]: '#clear-button',
};

export const hasMeasurableTarget = position =>
    isLetterPosition(position) || Boolean(POSITION_TARGETS[position]);

export default POSITION;
